<template>
  <NuxtLink
    class="border-blue text-blue rounded border px-2.5 py-1 text-lg !font-semibold no-underline"
    rel="noopener noreferrer nofollow"
    :to="!hasShare && `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`"
    @click="hasShare && onShare()"
  >
    {{ label }}
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string
  title: string
}>();

const   hasShare = ref(false);

const config = useRuntimeConfig();
const baseURL = config.public.appUrl;
const url = computed(() => `${baseURL}${useRoute().fullPath}`);

onMounted(() => hasShare.value = !!navigator?.share);

const onShare = () => navigator?.share({title: props.title, url: url.value});
</script>
